/* ============================================================================
   MARDANA LLC — THEME BULLION JAVASCRIPT
   Cart drawer, scroll reveals, nav shrink, FAQ toggles
   ============================================================================ */

(function() {
  'use strict';

  // ========== UTILITIES ==========
  var fmtMoney = function(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // ========== NAV SHRINK + STICKY BUTTON ON SCROLL ==========
  var nav = document.getElementById('vxNav');
  var buyBtn = document.getElementById('vxBuyNow');
  var stickyCheckout = document.getElementById('vxStickyCheckout');

  if (nav || buyBtn) {
    window.addEventListener('scroll', function() {
      // Nav shrink
      if (nav && window.scrollY > 40) {
        nav.classList.add('vx-shrink');
      } else if (nav) {
        nav.classList.remove('vx-shrink');
      }

      // Show sticky button when buy button is out of view
      if (buyBtn && stickyCheckout) {
        var rect = buyBtn.getBoundingClientRect();
        if (rect.top > window.innerHeight || rect.bottom < 0) {
          stickyCheckout.classList.add('vx-show');
        } else {
          stickyCheckout.classList.remove('vx-show');
        }
      }
    });
  }

  // Logo click: scroll to top
  var logoTop = document.getElementById('vxLogoTop');
  if (logoTop) {
    logoTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ========== LIVE VISITOR COUNT ==========
  var visitorCountEl = document.getElementById('vxVisitorCount');
  if (visitorCountEl) {
    var baseCount = 1 + Math.floor(Math.random() * 4); // 1-4 base visitors
    visitorCountEl.textContent = baseCount;

    // Simulate occasional visitor updates
    setInterval(function() {
      if (Math.random() > 0.7) {
        var newCount = baseCount + Math.floor(Math.random() * 3);
        visitorCountEl.textContent = Math.max(1, newCount);
      }
    }, 5000 + Math.random() * 10000);
  }

  // ========== YEAR AUTO-FILL ==========
  var yearEl = document.getElementById('vxYear');
  if (yearEl) {
    yearEl.textContent = new Date().getFullYear();
  }

  // ========== DYNAMIC STOCK UPDATES ==========
  function updateStockDisplay() {
    var urgencyBar = document.getElementById('vxUrgencyBar');
    var urgencyCount = document.getElementById('vxUrgencyCount');
    var stockBar = document.getElementById('vxStockBar');

    if (urgencyCount && urgencyBar) {
      var stock = parseInt(urgencyCount.textContent, 10);

      // Hide urgency bar if stock is high (>20)
      if (stock > 20) {
        urgencyBar.style.display = 'none';
      } else {
        urgencyBar.style.display = 'block';
      }

      // Hide stock bar if stock is very high (>50)
      if (stockBar && stock > 50) {
        stockBar.style.display = 'none';
      }
    }
  }

  // Initial check
  updateStockDisplay();

  // Update on variant change
  var variantSelect = document.getElementById('vxVariant');
  if (variantSelect) {
    variantSelect.addEventListener('change', updateStockDisplay);
  }

  // ========== SCROLL-REVEAL (IntersectionObserver) ==========
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('vx-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.vx-reveal').forEach(function(el) {
    io.observe(el);
  });

  // ========== CART DRAWER ==========
  var overlay = document.getElementById('vxOverlay');
  var drawer = document.getElementById('vxDrawer');
  var cartItemsEl = document.getElementById('vxCartItems');
  var subtotalEl = document.getElementById('vxSubtotal');
  var cartCountEl = document.getElementById('vxCartCount');
  var checkoutBtn = document.getElementById('vxCheckout');

  function openCart() {
    if (overlay && drawer) {
      overlay.classList.add('vx-open');
      drawer.classList.add('vx-open');
      renderCart();
    }
  }

  function closeCart() {
    if (overlay && drawer) {
      overlay.classList.remove('vx-open');
      drawer.classList.remove('vx-open');
    }
  }

  // Wire existing header cart button (cart-icon-bubble) to custom drawer
  var existingCartBtn = document.getElementById('cart-icon-bubble');
  if (existingCartBtn) {
    existingCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  }

  // Cart button click (backup for vxCartOpen if it exists)
  var cartOpenBtn = document.getElementById('vxCartOpen');
  if (cartOpenBtn) {
    cartOpenBtn.addEventListener('click', openCart);
  }

  // Close button click
  var cartCloseBtn = document.getElementById('vxCartClose');
  if (cartCloseBtn) {
    cartCloseBtn.addEventListener('click', closeCart);
  }

  // Overlay click closes
  if (overlay) {
    overlay.addEventListener('click', closeCart);
  }

  // ESC key closes
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCart();
    }
  });

  // ========== RENDER CART ==========
  function renderCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) {
        return r.json();
      })
      .then(function(cart) {
        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
        }
        if (subtotalEl) {
          subtotalEl.textContent = fmtMoney(cart.total_price);
        }

        if (!cartItemsEl) {
          return;
        }

        if (cart.items.length === 0) {
          cartItemsEl.innerHTML = '<div class="vx-cart-empty">Your cart is empty.</div>';
          return;
        }

        var html = '';
        cart.items.forEach(function(it) {
          var key = String(it.key);
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
          html += '<div class="vx-citem">' +
            (img ? '<img src="' + img + '" alt="">' : '') +
            '<div class="vx-citem-info">' +
            '<div class="vx-citem-title">' + (it.product_title || '') + '</div>' +
            '<div class="vx-citem-price">' + fmtMoney(it.final_line_price) + '</div>' +
            '<div class="vx-qty">' +
            '<button class="vx-cart-btn-minus" data-key="' + key + '" data-qty="' + (it.quantity - 1) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button class="vx-cart-btn-plus" data-key="' + key + '" data-qty="' + (it.quantity + 1) + '">&plus;</button>' +
            '</div>' +
            '<a class="vx-citem-remove vx-cart-btn-remove" data-key="' + key + '">Remove</a>' +
            '</div></div>';
        });
        cartItemsEl.innerHTML = html;

        // Attach event listeners to cart buttons
        document.querySelectorAll('.vx-cart-btn-minus, .vx-cart-btn-plus, .vx-cart-btn-remove').forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var key = btn.getAttribute('data-key');
            var qty = btn.getAttribute('data-qty');
            if (key && qty !== null) {
              window.vxCartChange(key, parseInt(qty, 10));
            }
          });
        });
      })
      .catch(function() {
        if (cartItemsEl) {
          cartItemsEl.innerHTML = '<div class="vx-cart-empty">Error loading cart.</div>';
        }
      });
  }

  // ========== CART CHANGE FUNCTION (global) ==========
  var cartChangeLock = false;
  var lastChangeTime = 0;
  var CHANGE_THROTTLE = 500; // minimum ms between requests

  window.vxCartChange = function(key, qty) {
    var now = Date.now();

    // Prevent duplicate requests within throttle window
    if (cartChangeLock || (now - lastChangeTime) < CHANGE_THROTTLE) {
      return;
    }

    cartChangeLock = true;
    lastChangeTime = now;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function(r) {
        return r.json();
      })
      .then(function() {
        renderCart();
      })
      .catch(function() {
        cartChangeLock = false;
      })
      .finally(function() {
        cartChangeLock = false;
      });
  };

  // Checkout button
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function(e) {
      e.preventDefault();
      window.location.href = '/checkout';
    });
  }

  // Initial cart count
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) {
      return r.json();
    })
    .then(function(c) {
      if (cartCountEl) {
        cartCountEl.textContent = c.item_count;
      }
    })
    .catch(function() {});

  // ========== LIVE SALES NOTIFICATIONS ==========
  var notificationsContainer = document.getElementById('vxNotificationsContainer');
  if (notificationsContainer) {
    var firstNames = ['John', 'Sarah', 'Michael', 'Emma', 'David', 'Lisa', 'James', 'Anna', 'Robert', 'Jessica', 'William', 'Maria', 'Richard', 'Jennifer', 'Thomas'];
    var lastInitials = ['M.', 'S.', 'K.', 'P.', 'J.', 'L.', 'W.', 'C.', 'R.', 'B.', 'D.', 'H.', 'T.', 'A.', 'E.'];

    var products = [
      '1 oz Silver Coin',
      'Roll of 20 Coins',
      'Monster Box (500)',
      '2026 Silver Eagle',
      'Roll of 200 Coins',
      'Gold Eagle Coin',
      'Silver Eagle BU',
      'Sealed Box'
    ];

    function getRandomItem(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    function getRandomTime() {
      var mins = Math.floor(Math.random() * 15) + 1;
      if (mins === 1) return 'just now';
      return mins + ' min' + (mins === 1 ? '' : 's') + ' ago';
    }

    function showNotification() {
      var firstName = getRandomItem(firstNames);
      var lastInitial = getRandomItem(lastInitials);
      var product = getRandomItem(products);
      var time = getRandomTime();

      var notif = document.createElement('div');
      notif.className = 'vx-notification';
      notif.innerHTML = '<span class="vx-notification-icon">✓</span>' +
        '<div class="vx-notification-text">' +
        '<strong>' + firstName + ' ' + lastInitial + '</strong> purchased <span class="vx-notification-product">' + product + '</span>' +
        '<div class="vx-notification-time">' + time + '</div>' +
        '</div>';

      notificationsContainer.appendChild(notif);

      // Keep max 3 notifications visible
      if (notificationsContainer.children.length > 3) {
        var oldest = notificationsContainer.children[0];
        oldest.classList.add('vx-out');
        setTimeout(function() {
          oldest.remove();
        }, 400);
      }

      // Auto-remove after 5 seconds
      setTimeout(function() {
        if (notif.parentElement) {
          notif.classList.add('vx-out');
          setTimeout(function() {
            if (notif.parentElement) {
              notif.remove();
            }
          }, 400);
        }
      }, 5000);
    }

    // Show initial notifications
    showNotification();
    setTimeout(function() { showNotification(); }, 3000);

    // Show new notifications every 8-15 seconds
    setInterval(function() {
      if (Math.random() > 0.3) {
        showNotification();
      }
    }, 8000 + Math.random() * 7000);
  }

  // ========== FAQ ACCORDION ==========
  document.querySelectorAll('.vx-faqitem').forEach(function(item) {
    var q = item.querySelector('.vx-faqq');
    var a = item.querySelector('.vx-faqa');
    if (q && a) {
      q.addEventListener('click', function() {
        var open = item.classList.contains('vx-open');
        document.querySelectorAll('.vx-faqitem').forEach(function(o) {
          o.classList.remove('vx-open');
          var aa = o.querySelector('.vx-faqa');
          if (aa) {
            aa.style.maxHeight = null;
          }
        });
        if (!open) {
          item.classList.add('vx-open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    }
  });
})();
